/* JMBD Theme JS */

// Mobile nav toggle
const navToggle = document.querySelector('.nav-toggle');
const siteNav = document.querySelector('.site-nav');
if (navToggle && siteNav) {
  navToggle.addEventListener('click', () => {
    const open = siteNav.classList.toggle('open');
    navToggle.setAttribute('aria-expanded', open);
  });
}

// Product page: thumbnail switcher
const thumbs = document.querySelectorAll('.product-thumb');
const mainImage = document.getElementById('product-main-image');
thumbs.forEach(thumb => {
  thumb.addEventListener('click', () => {
    if (mainImage) mainImage.src = thumb.dataset.src;
    thumbs.forEach(t => t.classList.remove('active'));
    thumb.classList.add('active');
  });
});

// Product page: variant selection
const variantRadios = document.querySelectorAll('input[name^="options"]');
variantRadios.forEach(radio => {
  radio.addEventListener('change', () => {
    const label = radio.closest('.option-swatch');
    if (!label) return;
    const group = label.closest('.option-values');
    group.querySelectorAll('.option-swatch').forEach(s => s.classList.remove('selected'));
    label.classList.add('selected');
  });
});

// Quantity buttons
document.querySelectorAll('.product-actions, .cart-item').forEach(ctx => {
  const minus = ctx.querySelector('.qty-minus');
  const plus = ctx.querySelector('.qty-plus');
  const input = ctx.querySelector('.qty-input');
  if (!input) return;
  minus?.addEventListener('click', () => {
    const v = parseInt(input.value, 10);
    if (v > 1) input.value = v - 1;
  });
  plus?.addEventListener('click', () => {
    input.value = parseInt(input.value, 10) + 1;
  });
});

// Cart: live quantity update via form submit on change
const cartForm = document.querySelector('form[action="/cart"]');
if (cartForm) {
  cartForm.querySelectorAll('.cart-qty-input').forEach(input => {
    input.addEventListener('change', () => cartForm.submit());
  });
}

// Scroll-based header shadow
const header = document.querySelector('.site-header');
if (header) {
  window.addEventListener('scroll', () => {
    header.style.boxShadow = window.scrollY > 8
      ? '0 2px 24px rgba(0,0,0,0.5)'
      : 'none';
  }, { passive: true });
}

// Size guide toggle
const sizeGuideBtn = document.querySelector('.size-guide-btn');
const sizeGuideTable = document.querySelector('.size-guide-table');
if (sizeGuideBtn && sizeGuideTable) {
  sizeGuideBtn.addEventListener('click', () => {
    const open = sizeGuideTable.hasAttribute('hidden');
    if (open) {
      sizeGuideTable.removeAttribute('hidden');
      sizeGuideBtn.setAttribute('aria-expanded', 'true');
      sizeGuideBtn.textContent = 'Size Guide −';
    } else {
      sizeGuideTable.setAttribute('hidden', '');
      sizeGuideBtn.setAttribute('aria-expanded', 'false');
      sizeGuideBtn.textContent = 'Size Guide +';
    }
  });
}
